import React from "react";
import Seo from "@/utils/seo";
import BannerCard from "@/components/ui/banner-card";
import Problem from "@/components/pages/initiatives/problem";
import Solution from "@/components/pages/initiatives/solution";
import SolutionGrid from "@/components/pages/initiatives/solution-grid";
import Divider from "@/components/pages/initiatives/divider";
import Head from "next/head";
import CaseStories from "@/components/pages/cri/case-stories";
import Section from "@/components/ui/section";
import Image from "next/image";
import Logistics from "@/components/ui/logistics";
export default function ClimateChange() {
  const seo = {
    slug: "/climate-change",
    metaTitle: "Climate Change | People’s Courage International, USA",
    metaDescription:
      "The mission of our initiative is to build the resilience of climate-affected informal workers by ensuring their access to climate-responsive social protection and adaptation supports.",
  };
  const jsonLd = {
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: "Climate Change | People’s Courage International, USA",
    description:
      "The mission of our initiative is to build the resilience of climate-affected informal workers by ensuring their access to climate-responsive social protection and adaptation supports.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3206 10th Street NE, Washington",
      addressLocality: "DC",
      postalCode: "20017",
      addressCountry: "USA",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+1202-573-8727",
      contactType: "customer support",
    },
  };

  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      {/* <BannerCard
        banner={{
          title: "Climate Week (New York)",
          image: "/images/cli/pexels-pixabay-60013.jpg",
        }}
        isActive={true}
        variant="single"
      /> */}
      <Problem
        title="What will we do"
        image="/images/cli/What will we do - Climate change micro page.webp"
        descriptionOne="We will be presenting our learnings and experiences from a <strong>multi-country research focused on the impact of climate change on migrant communities, conducted in conversation with over 23,915 migrant workers across five countries in South and Southeast Asia</strong>. In this convening community leaders and civil society representatives will share about the impact of climate change on migrants, workers and affected communities and why we need all hands on the deck to center workers and communities in the climate conversation."
      />

      <SolutionGrid
        sectionTitle="Agenda"
        columns={3}
        titleHeight="lg:h-12 h-8"
        data={[
          {
            title: "Panel discussion 1",
            heading:
              "Innovation for resilience of internal migrants and informal workers",
            image: "/images/icons/forum.png",
            description: `Discussions on the roadmap for grassroots efforts to participate and contribute to global advocacy on needs of informal workers and migrant communities, particularly in the context of climate change. The session will reflect on the models beyond philanthropy-funded ones to deliver on the social protection needs of the communities.  <br/><br/><strong>Date</strong>: 24 September, 2024<br/><strong>Time</strong>: 11.00 am to 12.00 PM`,
          },
          {
            title: "Panel discussion 2",
            heading: "Ramping up grassroots efforts",
            image: "/images/icons/forum.png",
            description: `Discussion between practitioners working at the grassroots across South Asia and Southeast Asia on how they are responding to the impact of climate change on communities, and what is required from them and other actors to drive greater action <br/><br/><strong>Date</strong>: 25 September, 2024<br/><strong>Time</strong>: 2.45pm to 3.30pm`,
          },
          {
            title: "Panel discussion 3",
            heading:
              "Communities, Climate Impacts and Systems Change: Linking Global and Local Efforts",
            image: "/images/icons/forum.png",
            description: `Discussion between actors across philanthropy, practitioners, climate advocacy organizations on how and what evidence, stories, demonstrations, and communications are needed to drive action, including how to break silos across climate and labour rights, and how to make collaborations across both. <br/><br/><strong>Date</strong>: 25 September, 2024<br/><strong>Time</strong>: 3.30pm-4.15pm`,
          },
        ]}
      />
      <Solution
        image="/images/cli/Who Will Participate - climate micro page.webp"
        description="Grassroot civil society organizations, philanthropies, government
            representatives, multilateral organizations, intermediaries and NGO
            collaboratives from across the world will participate in this
            discussion. <br/><br/>Around 100 people. ~50% from grassroots organizations
            from the global south. ~50% philanthropies, researchers,
            multilaterals, and other types of practitioners."
        heading="Who will participate"
        showLocation={true}
      />
      {/* <Section variant="flat">
        <Logistics />
      </Section> */}
    </>
  );
}
